
import IconButton from '@/ui-kit/components/icon-button';
import { IconButtonPropsEventType, IconButtonProperty } from '@/ui-kit/components/icon-button/enums';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { SoldDataTableEventType } from './enums';

export default {
  name: 'SoldDataTableVisibilityCell',
  components: {
    IconButton,
  },
  props: {
    isBode: {
      default: false,
      type: Boolean,
    },
    listingId: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      StyleSizeType,
      IconButtonPropsEventType,
      IconButtonProperty,
      IconType,
    };
  },
  computed: {
    visibilityColorScheme() {
      return this.isBode
        ? StyleColorSchemeType.White
        : StyleColorSchemeType.Black;
    },
  },
  methods: {
    toggleVisibility() {
      this.$emit(SoldDataTableEventType.ToggleVisibility, this.listingId);
    },
  },
};

